<template>
  <div class="special-exhibition" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
    <ModuleNav :normal="nav.normal" :hover="nav.hover" :isInModule="isInModule"/>
    <div class="right">
      <div class="head">
        <img :src="images[0]">
      </div>
      <div class="description">
        <h2>{{title}}</h2>
        <p v-for="(item,index) in paragraph" :key="index">
          {{item}}
        </p>
      </div>
      <div class="big-image">
        <img :src="images[1]" :style="{transform:`translate3d(${imagePosition}px,0,0)`}">
      </div>
      <div class="small-images">
        <img :src="images[2]" :style="{transform:`translate3d(${imagePosition}px,0,0)`}">
        <img :src="images[3]" :style="{transform:`translate3d(${imagePosition}px,0,0)`}">
        <img :src="images[4]" :style="{transform:`translate3d(${imagePosition}px,0,0)`}">
      </div>
    </div>
  </div>
</template>

<script>
  import ModuleNav from './ModuleNav';
  import { mapState } from 'vuex';

  export default {
    name: 'SpecialExhibition',
    components: { ModuleNav },
    computed: {
      ...mapState({
        images: state => state.specialExhibition.images,
        title: state => state.specialExhibition.title,
        paragraph: state => state.specialExhibition.paragraph,
        nav: state => state.specialExhibition.nav,
      })
    },
    data() {
      return {
        isInModule: false,
        scrollHeight: 0,
        imagePosition: 0,
      };
    },
    created() {
      window.addEventListener('scroll', this.handleScroll, false);
    },
    methods: {
      mouseEnter() {
        this.isInModule = true;
      },
      mouseLeave() {
        this.isInModule = false;
      },
      handleScroll() {
        const scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        const scrollInstance = scrollHeight - this.scrollHeight;
        this.scrollHeight = scrollHeight;
        const { left, width } = document.querySelector('.special-exhibition')
          .getBoundingClientRect();
        if (left <= document.body.offsetWidth && left >= -width) {
          if ((scrollInstance > 0 && this.imagePosition >= -width) || (scrollInstance < 0 && this.imagePosition <= 0)) {
            this.imagePosition -= scrollInstance / 50;
          }
        }
      }
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  };
</script>

<style scoped lang="less">
  .special-exhibition {
    display: flex;
    margin-left: 5vh;

    .right {
      height: 86vh;
      margin-top: 7vh;
      margin-left: 4vh;
      display: flex;
    }

    .head {
      width: 51vh;
      height: 100%;

      img {
        height: 100%;
        transition: transform .5s ease-out;
      }
    }

    .description {
      width: 45vh;
      height: 100%;
      padding: 0 5vh 0 0;
      display: flex;
      justify-content: center;
      flex-direction: column;

      h2 {
        font-size: 3vh;
      }

      p {
        margin-top: 2.7vh;
        line-height: 1.7;
        font-weight: 100;
        font-size: 2.2vh;
      }
    }

    .big-image {
      width: 51vh;
      margin-left: 5vh;
      height: 100%;

      img {
        height: 100%;
        transition: transform .5s ease-out;
      }
    }

    .small-images {
      width: 51vh;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: .7vh;

      img {
        width: 100%;
        transition: transform .5s ease-out;
      }
    }
  }
</style>
